module.exports = {
  rules: {
    'ad-hoc-sub-process': 'error',
    'event-sub-process-typed-start-event': 'error',
    'link-event': 'error',
    'no-duplicate-sequence-flows': 'warn',
    'sub-process-blank-start-event': 'error',
    'single-blank-start-event': 'error'
  }
};
